"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("../../assets/PPMultiSelect.css");
var PPMultiSelect = function (props) {
    var _a, _b;
    var _c = (0, react_1.useState)(false), listVisible = _c[0], setListVisible = _c[1];
    var _d = (0, react_1.useState)([]), selected = _d[0], setSelected = _d[1];
    var _e = (0, react_1.useState)(''), filter = _e[0], setFilter = _e[1];
    var _f = (0, react_1.useState)(false), topLimit = _f[0], setTopLimit = _f[1];
    var _g = (0, react_1.useState)(0), listTop = _g[0], setListTop = _g[1];
    var _h = (0, react_1.useState)(0), width = _h[0], setWidth = _h[1];
    (0, react_1.useEffect)(function () {
        setSelected(props.options.filter(function (o) { return o.selected; }).map(function (p) { return p.value; }));
    }, [props.options]);
    (0, react_1.useEffect)(function () {
        (!props.disabled && !props.readOnly) &&
            props.onChange({
                target: {
                    name: props.name,
                    value: props.options
                        .filter(function (o) { return selected.includes(o.value); })
                        .map(function (p) { return { value: p.value, label: p.label }; })
                }
            });
    }, [selected]);
    var changeVisibility = function (value) {
        (!props.disabled && !props.readOnly) &&
            setListVisible(value);
    };
    (0, react_1.useEffect)(function () {
        props.onFilter && (!props.disabled && !props.readOnly) &&
            props.onFilter(filter);
    }, [filter]);
    var getItemsSize = function () {
        var length = props.options.length;
        var filterSize = props.hideFilter ? 0 : 32;
        var val = !listVisible
            ?
                0
            :
                (props.top || topLimit ?
                    (length >= 6
                        ?
                            filterSize + (27 * 6)
                        :
                            ((length * 27) + filterSize))
                    :
                        filterSize + (length * 27)) + 6;
        return "".concat(val, "px");
    };
    (0, react_1.useEffect)(function () {
        window.addEventListener('scroll', function (event) {
            event.target.className !== 'items' &&
                setListVisible(false);
        }, true);
        return function () {
            window.removeEventListener("scroll", function () { }, true);
        };
    }, []);
    //Delay close 
    var timerVisibility;
    var onMouseLeave = function () {
        clearTimeout(timerVisibility);
        timerVisibility = setTimeout(function () { return changeVisibility(false); }, props.closeDelay || 250);
    };
    var calcItemsHeight = function () {
        var add = 6;
        !props.hideFilter &&
            (add += 32);
        !props.hideOptions &&
            (add += 36);
        //return props.hideFilter ? "calc(100% - 6px)" : "calc(100% - 38px)"
        return "calc(100% - ".concat(add, "px)");
    };
    return (react_1.default.createElement("div", { className: "pp-multiselect".concat(props.disabled ? " disabled" : "").concat(props.readOnly ? " readonly" : ""), ref: function (ref) {
            if (ref) {
                setTopLimit(Number(window.innerHeight) - ref.getBoundingClientRect().bottom < 216);
                var _top = 0;
                try {
                    _top = ref.getClientRects()[0].top;
                }
                catch (error) { }
                setListTop(_top);
                setWidth(ref.offsetWidth - 6 || 0);
            }
        }, style: { width: props.width || undefined }, onMouseOver: function () {
            var _a;
            (props.openTrigger === "hover" && !((_a = props.error) === null || _a === void 0 ? void 0 : _a.show)) &&
                changeVisibility(true);
            clearTimeout(timerVisibility);
        }, onMouseLeave: function () { onMouseLeave(); setFilter(""); }, onClick: function (event) {
            event.target.id === 'items' &&
                changeVisibility(!listVisible);
        } },
        props.title &&
            react_1.default.createElement("div", { className: "title" }, props.title),
        react_1.default.createElement("div", { className: "field".concat((!props.disabled && !props.readOnly) && props.required ? ' required' : '').concat(((_a = props.error) === null || _a === void 0 ? void 0 : _a.show) ? ' error' : '').concat(listVisible ? " active" : "") },
            react_1.default.createElement("div", { id: "items", className: "items" },
                selected.length === 0 &&
                    react_1.default.createElement("span", { className: "placeholder", onClick: function () { changeVisibility(!listVisible); } }, props.placeholder || ((props.openTrigger === "click" || ((_b = props.error) === null || _b === void 0 ? void 0 : _b.show)) && "Clique para selecionar")),
                selected.map(function (s, i) {
                    var _a;
                    return react_1.default.createElement("div", { key: i, className: "item", onClick: function () { changeVisibility(!listVisible); } }, (_a = props.options.find(function (o) { return o.value === s; })) === null || _a === void 0 ? void 0 : _a.label);
                }),
                react_1.default.createElement("div", { className: "shadow" })),
            react_1.default.createElement("div", { className: "icons" },
                !(props.required || props.readOnly || props.disabled) && selected.length > 0 &&
                    react_1.default.createElement("i", { className: "ppi ppi-x", onClick: function () { return setSelected([]); } }),
                react_1.default.createElement("i", { className: "ppi ppi-chevron-".concat(listVisible ? "up" : "down"), onClick: function () { return (!props.disabled || !props.readOnly) && changeVisibility(!listVisible); } }))),
        props.error && props.error.show && !listVisible &&
            react_1.default.createElement("div", { className: "help".concat(props.title ? "" : " wt").concat(props.right ? ' right' : '') },
                react_1.default.createElement("i", { className: "ppi ppi-chevron-up-alt" }),
                react_1.default.createElement("div", { className: "main" },
                    react_1.default.createElement("div", { className: "content" }, props.error.help))),
        react_1.default.createElement("div", { className: "list".concat(props.title ? "" : " wt").concat(props.top || topLimit ? " top" : "").concat(props.right ? ' right' : ''), style: {
                height: getItemsSize(),
                maxHeight: props.hideFilter ? 168 : 201,
                top: listTop,
                width: width
            } },
            !props.hideOptions &&
                react_1.default.createElement("div", { className: "options" },
                    props.options.find(function (o) { return !selected.includes(o.value); }) ?
                        react_1.default.createElement("span", { className: "option", onClick: function () { setSelected(props.options.map(function (o) { return o.value; })); } }, "Selecionar tudo")
                        :
                            react_1.default.createElement("span", { className: "option", onClick: function () { setSelected([]); } }, "Desselecionar tudo"),
                    react_1.default.createElement("span", { className: "option", onClick: function () {
                            setSelected(props.options.filter(function (o) { return !selected.includes(o.value); }).map(function (p) { return p.value; }));
                        } }, "Inverter")),
            !props.hideFilter &&
                react_1.default.createElement("div", { className: "search" },
                    react_1.default.createElement("i", { className: "ppi ppi-search ppi-2x text-grey" }),
                    react_1.default.createElement("input", { type: "text", value: filter, onChange: function (event) {
                            changeVisibility(true);
                            setFilter(event.target.value);
                        }, autoComplete: "off", placeholder: props.placeholderSearch, onClick: function () { props.openTrigger === "click" && changeVisibility(true); } }),
                    react_1.default.createElement("i", { className: "ppi ppi-x ppi-2x", onClick: function () { return setFilter(""); } })),
            react_1.default.createElement("div", { className: "items", style: { height: calcItemsHeight() } },
                react_1.default.createElement("input", { type: "hidden", name: props.name, value: props.options.filter(function (o) { return o.selected; }).map(function (o) { return o.value; }).join(',') }),
                props.options
                    .filter(function (o) { return selected.includes(o.value); })
                    .filter(function (o) { var _a; return (_a = o.label) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase().includes(filter.toLowerCase()); })
                    .map(function (o, i) {
                    var _selected = selected.includes(o.value);
                    return react_1.default.createElement("div", { key: i, className: "item".concat(_selected ? ' selected' : '').concat(o.disabled ? ' disabled' : ''), onClick: function () {
                            if (!o.disabled)
                                !_selected ? setSelected(__spreadArray(__spreadArray([], selected, true), [o.value], false)) : setSelected(selected.filter(function (s) { return s !== o.value; }));
                        } },
                        react_1.default.createElement("i", { className: "ppi ppi-checkbox".concat(_selected ? '-on' : '') }),
                        o.label);
                }),
                (selected.length > 0 && selected.length < props.options.length) &&
                    react_1.default.createElement("hr", null),
                props.options
                    .filter(function (o) { return !selected.includes(o.value); })
                    .filter(function (o) { var _a; return (_a = o.label) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase().includes(filter.toLowerCase()); })
                    .map(function (o, i) {
                    var _selected = selected.includes(o.value);
                    return react_1.default.createElement("div", { key: i, className: "item".concat(_selected ? ' selected' : '').concat(o.disabled ? ' disabled' : ''), onClick: function () {
                            if (!o.disabled)
                                !_selected ? setSelected(__spreadArray(__spreadArray([], selected, true), [o.value], false)) : setSelected(selected.filter(function (s) { return s !== o.value; }));
                        } },
                        react_1.default.createElement("i", { className: "ppi ppi-checkbox".concat(_selected ? '-on' : '') }),
                        o.label);
                })))));
};
exports.default = PPMultiSelect;
